var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"emd-nav-list",class:{
            '_direction_column': _vm.column,
            '_border': _vm.border
        }},[_c('ul',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }